import mockAxios, { AxiosResponse } from 'axios';

import { ITimeOffRequestServiceMock } from './timeoff-request.mock.types';

export const mockTimeOffRequestService = (): ITimeOffRequestServiceMock => ({
  fetchTimeOffRequests: jest.fn(),
  fetchTimeOffRequest: jest.fn(),
  createTimeOffRequest: jest.fn(),
  updateTimeOffRequest: jest.fn(),
  deleteTimeOffRequest: jest.fn(),

  exportTimeOffRequestsXLSX: jest.fn(),

  updateTimeOffRequestState: jest.fn(),

  downloadTimeOffAttachment: jest.fn(),
  deleteTimeOffAttachment: jest.fn(),
  fetchTimeOffRequestActivities: jest.fn(),

  // TIME-OFF COMMENTS
  fetchTimeOffRequestComments: jest.fn(),
  fetchTimeOffRequestComment: jest.fn(),
  createTimeOffRequestComment: jest.fn(),
  updateTimeOffRequestComment: jest.fn(),
  deleteTimeOffRequestComment: jest.fn(),

  addTimeOffRequestCommentAttachments: jest.fn(),
  removeTimeOffRequestCommentAttachment: jest.fn(),

  fetchTimeOffRequestCommentsMentionableUsers: jest.fn()
});

export const mockTimeOffAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
